// extracted by mini-css-extract-plugin
export default {"fullWidth":"np-z","image":"op-z","lazyLoadPicture":"pp-z","lazyLoadSpinner":"qp-z","lazyLoadSpin":"rp-z","lazyLoadImage":"sp-z","hasStyledAspectRatio":"tp-z"};